'use strict';

/**
 * NavigationButton
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.NavigationButton = T.createModule({

	_stateClasses: {
		open: 'state-open',
		closed: 'state-closed'
	},

	_eventNames: {
		click: 'navigation-button-click',
		close: 'navigation-button-close',
		documentClick: 'navigation-button-document-click'
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		this.icon = this.$ctx.data('type');
		this.component = this.mapIconToComponent[this.icon];
		this.isOpen = false;

		// Global Event Binding
		// A navigation element was open and escape key was pressed => close
		this._events.on(this._eventNames.close, this.onClose.bind(this));
		// A navigation element was open and a click around it originated => close if not a button
		this._events.on(this._eventNames.documentClick, this.$onDocumentClick.bind(this));

		// Component Event Binding
		this.$ctx.click(this.$onClick.bind(this));

		resolve();
	},


	mapIconToComponent: {
		menu: 'navigation-flyout',
		globe: 'navigation-language',
		search: 'navigation-search'
	},

	$onClick: function $onClick() {
		// if the click was on the download icon, we do nothing here
		if (this.icon === 'download') {
			return true;
		}

		this.toggle();
		this._events.emit(this._eventNames.close, this.icon);
	},
	$onDocumentClick: function $onDocumentClick() {
		// Clicks on navigation-buttons handled by $onClick, so ignore them
		if (this.isOpen) {
			this.close();
		}
	},
	onClose: function onClose(icon) {
		if (this.isOpen && icon !== this.icon) {
			this.close();
		}
	},
	toggle: function toggle() {
		this.$ctx.toggleClass(this._stateClasses.open);
		this.$ctx.toggleClass(this._stateClasses.closed);
		this._events.emit(this.component + '-toggle');
		this.isOpen = !this.isOpen;
	},
	close: function close() {
		this.$ctx.removeClass(this._stateClasses.open);
		this.$ctx.addClass(this._stateClasses.closed);
		if (this.isOpen) {
			this._events.emit(this.component + '-toggle');
		}
		this.isOpen = false;
	}
});